var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import PickerField from "./PickerField.js";
import Objects from "../helper/util/Objects.js";
import EventHelper from "../helper/EventHelper.js";
const _TextAreaPickerField = class _TextAreaPickerField extends PickerField {
  get inputElement() {
    const result = super.inputElement;
    result.readOnly = "readonly";
    result.reference = "displayElement";
    this.ariaElement = "displayElement";
    return result;
  }
  get nonEditableClickTarget() {
    return this.displayElement;
  }
  get focusElement() {
    var _a;
    return ((_a = this._picker) == null ? void 0 : _a.isVisible) ? this.input : this.displayElement;
  }
  get needsInputSync() {
    var _a;
    return this.displayElement[this.inputValueAttr] !== String((_a = this.inputValue) != null ? _a : "");
  }
  showPicker() {
    this.picker.width = this.pickerWidth || this.pickerAlignElement.offsetWidth;
    super.showPicker(true);
  }
  focusPicker() {
    this.input.focus();
  }
  onPickerKeyDown(keyEvent) {
    const me = this, realInput = me.input;
    switch (keyEvent.key.trim() || keyEvent.code) {
      case "Escape":
        me.picker.hide();
        return;
      case "Enter":
        if (keyEvent.ctrlKey) {
          me.syncInputFieldValue();
          me.picker.hide();
        }
        break;
    }
    me.input = me.displayElement;
    const result = super.onPickerKeyDown(keyEvent);
    me.input = realInput;
    return result;
  }
  syncInputFieldValue(skipHighlight) {
    if (this.displayElement) {
      this.displayElement.value = this.inputValue;
    }
    super.syncInputFieldValue(skipHighlight);
  }
  changeValue(value) {
    return value == null ? "" : value;
  }
  changePicker(picker, oldPicker) {
    var _a;
    const me = this, pickerWidth = me.pickerWidth || (picker == null ? void 0 : picker.width);
    picker = _TextAreaPickerField.reconfigure(oldPicker, picker ? Objects.merge({
      owner: me,
      forElement: me.pickerAlignElement,
      align: {
        matchSize: pickerWidth == null,
        anchor: me.overlayAnchor,
        target: me.pickerAlignElement
      },
      id: me.id + "-input",
      style: {
        resize: me.resize
      },
      html: (_a = me.value) != null ? _a : ""
    }, picker) : null, me);
    if (picker) {
      const input = me.input = picker.element;
      me.inputListenerRemover = EventHelper.on({
        element: input,
        thisObj: me,
        focus: "internalOnInputFocus",
        change: "internalOnChange",
        input: "internalOnInput",
        keydown: "internalOnKeyEvent",
        keypress: "internalOnKeyEvent",
        keyup: "internalOnKeyEvent"
      });
    }
    return picker;
  }
};
__publicField(_TextAreaPickerField, "$name", "TextAreaPickerField");
__publicField(_TextAreaPickerField, "type", "textareapickerfield");
__publicField(_TextAreaPickerField, "configurable", {
  /**
   * @hideconfigs editable
   */
  picker: {
    type: "widget",
    tag: "textarea",
    cls: "b-textareapickerfield-picker",
    scrollAction: "realign",
    align: {
      align: "t-b",
      axisLock: true
    },
    autoShow: false
  },
  triggers: {
    expand: {
      cls: "b-icon-picker",
      handler: "onTriggerClick"
    }
  },
  /**
   * The resize style to apply to the `<textarea>` element.
   * @config {'none'|'both'|'horizontal'|'vertical'}
   * @default
   */
  resize: "none",
  inputType: null,
  // Private at this level. The "display" element is always readonly.
  // editing takes place in the picker.
  editable: false
});
let TextAreaPickerField = _TextAreaPickerField;
TextAreaPickerField.initClass();
TextAreaPickerField._$name = "TextAreaPickerField";
export {
  TextAreaPickerField as default
};
